import { FC, ReactNode } from 'react';
import { Box, Stack, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import PageLink from '../../page-link';
import classNames from 'classnames';

interface Props {
  resourceId: string;
  leftElement?: ReactNode;
  fullWidth?: boolean;
}

const useStyles = createUseStyles<string, { isUserEvent: boolean }>((theme: Theme) => ({
  conversationHeader: {
    padding: '8px 20px',
    flexShrink: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: '0px -20px',
    width: 'calc(100% + 40px)',
    '&.full-width': {
      width: '100%',
      margin: 0,
    },
  },
}));

const ConversationHeader: FC<Props> = ({ resourceId, leftElement, fullWidth = false }) => {
  const styles = useStyles();

  const compClass = classNames(styles.conversationHeader, { 'full-width': fullWidth });

  return (
    <Box className={compClass} boxSizing="border-box">
      <Stack direction="row" gap={2}>
        <Stack direction="row" gap={2} alignItems="center">
          {leftElement}
        </Stack>
        <Stack direction="row" gap={2} alignItems="center" justifyContent="flex-end" width="100%">
          <PageLink routeKey="audit-logs" search={{ resourceId }} size="small" />
        </Stack>
      </Stack>
    </Box>
  );
};

export default ConversationHeader;
